import { LatLngLiteral } from 'leaflet';
import { MapContainer } from 'react-leaflet';
import SatelliteLayer from './SatelliteLayer';
import './map.css';

const ZOOM_DEFAULT = 14;

interface IMapProps {
  className?: string;
  zoom?: number;
  center: LatLngLiteral | null;
  isSatellite?: boolean;
  markers?: React.ReactNode;
  scrollWheelZoom?: boolean;
  geoJson?: React.ReactNode;
}

function Map({
  className,
  zoom = ZOOM_DEFAULT,
  center,
  isSatellite = false,
  markers = [],
  scrollWheelZoom = false,
  geoJson,
}: IMapProps) {
  if (!center) return null;

  return (
    <MapContainer
      center={[center.lat as number, center.lng as number]}
      zoom={zoom}
      scrollWheelZoom={scrollWheelZoom}
      className={className}
    >
      {markers}
      {geoJson}
      <SatelliteLayer satelliteView={isSatellite} />
    </MapContainer>
  );
}

export default Map;
